import { LOCALES } from '../locales';

const hi = {
    [LOCALES.HINDI]: {
        'title': 'बॉयलरप्लेट',
        'welcome': 'स्वागत हे'
    }
}

export default hi;